// src/components/Portfolio/DeficienciesObjects/GreenTeaExtract.js

const Osteoniplex = {
  productCode: "SBOVZ-OSX",
  productName: "Osteoniplex",
  ingredients: "Commiphora wightii Oleoresin; Asparagus densiflorus; Grape seed extract: Withania somnifera: Cissus quadrangularis; Medicago sativa",
  overview:"Botanical and whole food Anti Inflammatory Supplement",
  assay:" Vitamin K2: 25 mcg; Vitamin D3: 300 IU Commiphora wightii Oleoresin: 100 mg; Asparagus densiflorus extract: 100 mg; Grape seed extract:50 mg; Withania somnifera extract:10 mg; Cissus quadrangularis extract: 50 mg; ; Medicago sativa extract: 137 mg",
  coNutrients:"Vitamins D3, B12, B6, K2, Ca, Mg, Se, Zn",
  studies:"",
  benefits:"Osteoporosis is a disease that drastically affects the quality of life in a time when quality should be assured. Osteoniplex offers you better lifestyle when you reach your golden years. It helps build the bone matrix, improves your immune health and provides support to your muscles. Bone remineralization, bone density and fracture healing support of Osteoniplex makes it an important food supplement. It offers a balance of both vitamins and herbal actives that enables stable bone health. ",
  functionalUse: {
    main: "💊︎ Capsule",
    note: "(Note:- heat and light sensitive, prone to oxidative stress)"
  },
  bannerImage: [
    "images/Portfolio/OrgavitazForConditions/Osteoniplex.png"
    

  ],
  certificates: [
     "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L1.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L2.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L3.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L4.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L6.png",
  ]
};

export default Osteoniplex;
